export default "__VITE_ASSET__81b6aa70__"